import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { OktaWrapperService } from '@mysrc/services/framework/okta-wrapper.service';
import { AppInsightsService } from "../services/app-insights.service";
import { LoggingService } from "../services/logging.service";

/**
 * Global error handler — intercepts all unhandled errors and logs them
 * to Application Insights and the logging service.
 * Uses Injector to avoid circular dependency issues with injected services.
 */
@Injectable({
  providedIn: 'root'
})
export class ApplicationInsightsErrorHandler extends ErrorHandler {

  constructor(
    private injector: Injector,
    private oktaWrapper: OktaWrapperService
  ) {
    super();
  }

  /** Handles all unhandled errors — logs to AppInsights with current user context. */
  public handleError(error: any): void {

    // Resolve user from cached token — synchronous, no async needed
    // getUser() reads from heldToken which is already in memory
    const userClaim = this.oktaWrapper.getUser();
    const user: string = userClaim?.sub ?? '';

    this.injector.get<AppInsightsService>(AppInsightsService).logException(error);
    this.injector.get<LoggingService>(LoggingService).log(error, user);

    super.handleError(error);
  }
}
